import { GET_CUSTOMERINVOICE_REQUEST, GET_CUSTOMERINVOICE_SUCCESS, GET_CUSTOMERINVOICE_FAIL,
    CREATE_CUSTOMERINVOICE_REQUEST, CREATE_CUSTOMERINVOICE_SUCCESS, CREATE_CUSTOMERINVOICE_FAIL,
    UPDATE_CUSTOMERINVOICE_REQUEST, UPDATE_CUSTOMERINVOICE_SUCCESS, UPDATE_CUSTOMERINVOICE_FAIL,
    DELETE_CUSTOMERINVOICE_REQUEST, DELETE_CUSTOMERINVOICE_SUCCESS, DELETE_CUSTOMERINVOICE_FAIL,
    GET_PENALTIES_REQUEST, GET_PENALTIES_SUCCESS, GET_PENALTIES_FAIL } from "../types/customerInvoiceTypes";

function deleteCustomerInvoiceReducer( state = { deleteCustomerInvoice: {}}, action) {
    switch (action.type) {
        case DELETE_CUSTOMERINVOICE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_CUSTOMERINVOICE_SUCCESS:
            return {
                ...state,
                deleteCustomerInvoice: action.payload,
                isLoading: false
            }       
        case DELETE_CUSTOMERINVOICE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateCustomerInvoiceReducer( state = { updateCustomerInvoice: {}}, action) {
    switch (action.type) {
        case UPDATE_CUSTOMERINVOICE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_CUSTOMERINVOICE_SUCCESS:
            return {
                ...state,
                updateCustomerInvoice: action.payload,
                isLoading: false
            }       
        case UPDATE_CUSTOMERINVOICE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function createCustomerInvoiceReducer( state = { createCustomerInvoice: {}}, action) {
    switch (action.type) {
        case CREATE_CUSTOMERINVOICE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_CUSTOMERINVOICE_SUCCESS:
            return {
                ...state,
                createCustomerInvoice: action.payload,
                isLoading: false
            }       
        case CREATE_CUSTOMERINVOICE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getCustomerInvoiceReducer( state = { customerInvoice: []}, action) {
    switch (action.type) {
        case GET_CUSTOMERINVOICE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_CUSTOMERINVOICE_SUCCESS:
            return {
                ...state,
                customerInvoice: action.payload,
                isLoading: false
            }       
        case GET_CUSTOMERINVOICE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getPenaltiesReducer( state = { billPenalties: []}, action) {
    switch (action.type) {
        case GET_PENALTIES_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PENALTIES_SUCCESS:
            return {
                ...state,
                billPenalties: action.payload,
                isLoading: false
            }       
        case GET_PENALTIES_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { getCustomerInvoiceReducer, createCustomerInvoiceReducer, updateCustomerInvoiceReducer, deleteCustomerInvoiceReducer, getPenaltiesReducer }